import React, { FC } from "react";
import { FormattedMessage } from "@I18n/Components/FormattedMessage/FormattedMessage";
import { PaymentMethodCard } from "../../../../Components/PaymentMethodCard/PaymentMethodCard";
import messages from "./messages";
import { IPaymentMethod } from "@modules/PaymentProcessing/services/paymentMethods";
import { PaymentMethodType } from "@modules/PaymentProcessing/types";

interface Props {
  onClick: (paymentMethod: IPaymentMethod) => void;
  disabled?: boolean;
}

export const CreditCardPaymentCard: FC<Props> = ({ onClick, disabled }) => {
  return (
    <PaymentMethodCard
      title={<FormattedMessage {...messages.creditCard} />}
      onClick={onClick}
      cardNetworkIcons={["visa", "mastercard", "americanExpress"]}
      value={PaymentMethodType.CREDIT_CARD}
      disabled={disabled}
      data-testid="credit-card-payment-link"
      disabledModalTitle={<FormattedMessage {...messages.noCreditCard} />}
      disabledModalContent={
        <FormattedMessage
          {...messages.creditCardTransactionsAreNotSupportedForThisService}
        />
      }
    />
  );
};
